import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4824_71881)">
      <path
        d="M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z"
        fill="url(#paint0_radial_4824_71881)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_4824_71881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.9752 14.6145) scale(45.1744)"
      >
        <stop offset="0.0677083" stopColor="#ECEDEE" />
        <stop offset="0.25" stopColor="#787F85" />
        <stop offset="0.473958" stopColor="#4C5155" />
        <stop offset="0.880208" stopColor="#26292B" />
        <stop offset="1" stopColor="#313538" />
      </radialGradient>
      <clipPath id="clip0_4824_71881">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
